import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1bf817e0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "main-slider"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slider-numbers"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "main-num-current"
}), /*#__PURE__*/_createTextVNode("/"), /*#__PURE__*/_createElementVNode("span", {
  class: "main-num-all"
})], -1));

const _hoisted_3 = {
  ref: "slider",
  class: "slider"
};
const _hoisted_4 = {
  class: "slide-block"
};
const _hoisted_5 = {
  class: "slide-content"
};
const _hoisted_6 = {
  class: "slide-content-wrap"
};
const _hoisted_7 = {
  class: "slide-title"
};
const _hoisted_8 = {
  class: "slide-text"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "main"
};
const _hoisted_12 = {
  class: "holder holder-fluid"
};
const _hoisted_13 = {
  key: 0,
  class: "new-works"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Новинки", -1));

const _hoisted_15 = {
  class: "new-works-list",
  ref: "newWorkSlider"
};
const _hoisted_16 = {
  class: "wrap"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "cover"
};
const _hoisted_19 = {
  key: 0,
  class: "characteristics"
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = {
  class: "item-description"
};
const _hoisted_22 = {
  class: "item-author"
};
const _hoisted_23 = {
  class: "item-name"
};
const _hoisted_24 = {
  class: "button-wrap"
};
const _hoisted_25 = {
  class: "item-button"
};
const _hoisted_26 = {
  class: "first"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  class: "main-catalog"
};
const _hoisted_30 = {
  class: "line"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Коллекция", -1));

const _hoisted_32 = {
  class: "line-right"
};
const _hoisted_33 = {
  class: "catalog"
};
const _hoisted_34 = {
  class: "show-all"
};

const _hoisted_35 = /*#__PURE__*/_createTextVNode("Смотреть всю коллекцию");

const _hoisted_36 = {
  key: 1,
  class: "main-caterory"
};
const _hoisted_37 = {
  class: "main-caterory-block"
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "main-caterory-caption"
};
const _hoisted_40 = {
  class: "main-caterory-title"
};
const _hoisted_41 = {
  class: "main-caterory-text"
};
const _hoisted_42 = {
  key: 2,
  class: "catalog-slider-section"
};

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Подборки", -1));

const _hoisted_44 = {
  class: "catalog-slider-wrap"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slider-numbers"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "catalog-num-current"
}), /*#__PURE__*/_createTextVNode("/"), /*#__PURE__*/_createElementVNode("span", {
  class: "catalog-num-all"
})], -1));

const _hoisted_46 = {
  ref: "catalogSlider",
  class: "catalog-slider"
};
const _hoisted_47 = {
  class: "catalog-item"
};
const _hoisted_48 = {
  class: "catalog-img"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  class: "catalog-cover"
};

const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Перейти ");

const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6471 9.24984L10.6327 5.55143L11.649 4.44824L17.0762 9.44824L17.675 9.99984L17.0762 10.5514L11.649 15.5514L10.6327 14.4482L14.6471 10.7498H3V9.24984H14.6471Z",
  fill: "black"
})], -1));

const _hoisted_53 = {
  class: "catalog-author"
};
const _hoisted_54 = {
  class: "catalog-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_WorksFilterComponent = _resolveComponent("WorksFilterComponent");

  const _component_EmptyResultComponent = _resolveComponent("EmptyResultComponent");

  const _component_WorkCardComponent = _resolveComponent("WorkCardComponent");

  const _directive_img = _resolveDirective("img");

  return _openBlock(), _createElementBlock(_Fragment, null, [$data.Sliders.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Sliders, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "slide",
      key: item.id
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.description), 1), item.url ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: item.url,
      class: "button"
    }, "Подробнее", 8, _hoisted_9)) : _createCommentVNode("", true)])]), (_openBlock(), _createBlock(_resolveDynamicComponent(item.url ? 'a' : 'div'), {
      href: item.url,
      class: "slide-img"
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_10)]),
      _: 2
    }, 1032, ["href"]))])]);
  }), 128))], 512)])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_11, [_createElementVNode("div", _hoisted_12, [$data.newWorks.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newWorks, item => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "item",
      key: item.id
    }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_router_link, {
      to: {
        name: 'work',
        params: {
          id: item.work.id
        }
      },
      class: "item-img"
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: item.work.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, [item.work.characteristics.length ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.work.characteristics, (characteristic, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [characteristic.name !== 'Информация' ? (_openBlock(), _createElementBlock("li", _hoisted_20, _toDisplayString(characteristic.name) + ": " + _toDisplayString(characteristic.value), 1)) : _createCommentVNode("", true)], 64);
      }), 128))])) : _createCommentVNode("", true)])]),
      _: 2
    }, 1032, ["to"]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_router_link, {
      to: {
        name: 'author',
        params: {
          id: item.work.author.id
        }
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.work.author.name), 1)]),
      _: 2
    }, 1032, ["to"])]), _createElementVNode("div", _hoisted_23, _toDisplayString(item.work.name), 1), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(item.work.price || 'Узнать цену'), 1), item.work.price.search(/\d/) !== -1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "last",
      onClick: $event => {
        $options.openBuyModal();
        $data.buyWorkId = item.work.id;
      }
    }, "Купить", 8, _hoisted_27)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "last",
      onClick: $event => {
        $options.openPriceModal();
        $data.priceWorkId = item.work.id;
      }
    }, "Узнать цену", 8, _hoisted_28))])])])])])), [[_directive_img, {
      classes: ['.item-img img']
    }]]);
  }), 128))], 512)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createVNode(_component_WorksFilterComponent, {
    onFiltered: _cache[0] || (_cache[0] = (authorIds, years) => $options.filterWorks(authorIds, years))
  })])]), _createElementVNode("div", _hoisted_33, [$data.worksLoader.load && !$data.Works.length ? (_openBlock(), _createBlock(_component_EmptyResultComponent, {
    key: 0,
    title: $data.worksLoader.title,
    description: $data.worksLoader.description
  }, null, 8, ["title", "description"])) : _createCommentVNode("", true), _createVNode(_component_WorkCardComponent, {
    works: $data.Works
  }, null, 8, ["works"])]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_router_link, {
    to: {
      name: 'works'
    },
    class: "button after-arrow"
  }, {
    default: _withCtx(() => [_hoisted_35]),
    _: 1
  })])]), $data.Categories.length ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Categories, item => {
    return _openBlock(), _createBlock(_component_router_link, {
      to: {
        name: 'category',
        params: {
          id: item.id
        }
      },
      class: "main-caterory-item",
      key: item.id
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_38), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(item.description), 1)])]),
      _: 2
    }, 1032, ["to"]);
  }), 128))])])) : _createCommentVNode("", true), $data.Compilations.length ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Compilations, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "catalog-slide",
      key: item.id
    }, [_createElementVNode("div", _hoisted_47, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("img", {
      src: item.thumbWithPath,
      alt: ""
    }, null, 8, _hoisted_49), _createElementVNode("div", _hoisted_50, [_createVNode(_component_router_link, {
      to: {
        name: 'compilation',
        params: {
          id: item.id
        }
      },
      class: "catalog-cover-more",
      style: {
        "cursor": "pointer"
      }
    }, {
      default: _withCtx(() => [_hoisted_51, _hoisted_52]),
      _: 2
    }, 1032, ["to"])])])), [[_directive_img, {
      classes: ['img']
    }]]), _createElementVNode("div", _hoisted_53, [_createVNode(_component_router_link, {
      to: {
        name: 'compilation',
        params: {
          id: item.id
        }
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
      _: 2
    }, 1032, ["to"])]), _createElementVNode("div", _hoisted_54, _toDisplayString(item.description), 1)])]);
  }), 128))], 512)])])) : _createCommentVNode("", true)])])], 64);
}